import { render, staticRenderFns } from "./CenteredLogoSimpleHeader.vue?vue&type=template&id=027e56a9&scoped=true&"
import script from "./CenteredLogoSimpleHeader.vue?vue&type=script&lang=js&"
export * from "./CenteredLogoSimpleHeader.vue?vue&type=script&lang=js&"
import style0 from "./CenteredLogoSimpleHeader.vue?vue&type=style&index=0&id=027e56a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e56a9",
  null
  
)

export default component.exports